// tslint:disable
export var EnrollmentScenario;
(function (EnrollmentScenario) {
    // Nothing/error rout
    EnrollmentScenario[EnrollmentScenario["Undetermined"] = 0] = "Undetermined";
    // create a new initial enrollment or an enrollment after a time gap
    EnrollmentScenario[EnrollmentScenario["NewEnrollment"] = 1] = "NewEnrollment";
    // update an existing enrollment
    EnrollmentScenario[EnrollmentScenario["Update"] = 2] = "Update";
    // end an existing enrollment early and create a new one for the remaining time 
    EnrollmentScenario[EnrollmentScenario["KeyUpdate"] = 3] = "KeyUpdate";
    // create a new enrollment in the future, despite the patient having a current enrollment
    EnrollmentScenario[EnrollmentScenario["ReEnrollment"] = 4] = "ReEnrollment";
    // End all existing enrollments without creating anything new.
    EnrollmentScenario[EnrollmentScenario["DisEnrollment"] = 5] = "DisEnrollment";
})(EnrollmentScenario || (EnrollmentScenario = {}));
EnrollmentScenario['UNDETERMINED'] = 0;
EnrollmentScenario['NEWENROLLMENT'] = 1;
EnrollmentScenario['UPDATE'] = 2;
EnrollmentScenario['KEYUPDATE'] = 3;
EnrollmentScenario['REENROLLMENT'] = 4;
EnrollmentScenario['DISENROLLMENT'] = 5;
//# sourceMappingURL=EnrollmentScenario.js.map